import React, { useState } from "react";
import { Button } from "@radix-ui/themes";
import { LogIn } from "lucide-react";
import { useSupaContext } from "../../../contexts/SupaContext";
import { UserInfoSection } from "./UserInfoSection"; // Asumiendo que has desacoplado este componente
import { DeliveryAddressSelector } from "./DeliveryAddressSelector"; // Asumiendo que has desacoplado este componente
import MultiSidePanel from "../../ui/MultiSidePanel"; // Asegúrate que la ruta sea correcta
import AddressFormForPanel from "./AddressFormForPanel";

// Componente Principal de la Sección de Entrega
export const DeliverySection = ({ setAccessModalOpen }) => {
  const { isActiveUser } = useSupaContext();
  const [isAddressPanelOpen, setIsAddressPanelOpen] = useState(false);
  const [addressPanelContent, setAddressPanelContent] = useState(null);

  // Abrir panel para NUEVA dirección
  const handleOpenNewAddressPanel = () => {
    setAddressPanelContent(
      <AddressFormForPanel onClose={() => setIsAddressPanelOpen(false)} />
    );
    setIsAddressPanelOpen(true);
  };

  return (
    <div className="flex flex-col gap-6">
      {/* Mostrar info de usuario si no está logueado */}
      {!isActiveUser && (
        <UserInfoSection setAccessModalOpen={setAccessModalOpen} />
      )}

      {/* Selector de dirección o botón de login */}
      <div className="w-full transition-opacity duration-300">
        <div className="bg-white flex flex-col rounded-xl">
          {" "}
          {/* Añadido padding */}
          {isActiveUser ? (
            // Muestra direcciones guardadas y botón para añadir nueva
            <DeliveryAddressSelector onNewAddress={handleOpenNewAddressPanel} />
          ) : (
            // Muestra mensaje para iniciar sesión
            <div className="text-center p-6">
              <p className="text-gray-700 mb-4">
                Inicia sesión o regístrate para gestionar tus direcciones de
                entrega.
              </p>
              <Button
                className="bg-blue-600 hover:bg-blue-700 text-white"
                onClick={() => setAccessModalOpen(true)}
              >
                <LogIn className="mr-2 h-4 w-4" />
                Iniciar sesión o registrarse
              </Button>
            </div>
          )}
        </div>
      </div>

      {/* Panel lateral para crear/editar direcciones */}
      <MultiSidePanel
        isOpen={isAddressPanelOpen}
        onClose={() => setIsAddressPanelOpen(false)}
        title="Nueva dirección" // El título puede cambiar si se implementa edición
        width="480px" // O el ancho que prefieras
        content={addressPanelContent}
      />
    </div>
  );
};